import { baseApi } from './baseApi';

/**
 * Languages API endpoints
 * Handles language data fetching
 */
export const languagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /languages - Fetch all languages
    getLanguages: builder.query({
      query: () => '/languages',
      providesTags: ['Language'],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetLanguagesQuery,
} = languagesApi;

